import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomahabaleshwartempotraveller() {



  const cardData = {
"keyword": "Pune to Mahabaleshwar Tempo Traveller on Rent",

"headingDescription":
  "Shivai Travels offers reliable Pune to Mahabaleshwar Tempo Traveller on rent for comfortable group travel including family tours, corporate outings, school trips, wedding groups, and weekend getaways. Our Tempo Traveller service is ideal for long scenic road journeys from Pune to Mahabaleshwar, providing spacious pushback seating, powerful air conditioning, clean and well-maintained interiors, charging points, music system, and ample luggage space for a smooth travel experience. Suitable for 9–17 passengers, our vehicles ensure everyone travels together comfortably with experienced drivers skilled in ghats and hill routes. Shivai Travels provides flexible rental options including one-way trips, round trips, customized sightseeing packages, doorstep pickup and drop, and 24/7 customer support for a safe and hassle-free journey to Mahabaleshwar from Pune.",

"topPlaces": [
  {
    "title": "Arthur's Seat",
    "description":
      "Arthur's Seat is one of the most famous viewpoints in Mahabaleshwar offering breathtaking views of valleys, cliffs, and the Savitri River, ideal for group sightseeing."
  },
  {
    "title": "Venna Lake",
    "description":
      "Venna Lake is a popular tourist attraction in Mahabaleshwar known for boating, horse rides, and scenic surroundings, perfect for family and group outings."
  },
  {
    "title": "Mapro Garden",
    "description":
      "Mapro Garden is a famous strawberry garden and food park known for fresh strawberries, juices, chocolates, and scenic picnic spaces for visitors."
  },
  {
    "title": "Wilson Point",
    "description":
      "Wilson Point is the highest point in Mahabaleshwar offering stunning sunrise and sunset views, making it a must-visit for group travelers."
  },
  {
    "title": "Lingmala Waterfall",
    "description":
      "Lingmala Waterfall is a beautiful natural waterfall surrounded by greenery, ideal for monsoon visits and scenic group trips."
  },
  {
    "title": "Elephant's Head Point",
    "description":
      "Elephant's Head Point is a popular cliff viewpoint shaped like an elephant’s head, offering panoramic valley views and photo opportunities."
  },
  {
    "title": "Panchgani Table Land",
    "description":
      "Table Land in Panchgani is a vast plateau known for horse riding, sightseeing, and scenic landscapes, located near Mahabaleshwar."
  },
  {
    "title": "Pratapgad Fort",
    "description":
      "Pratapgad Fort is a historic Maratha fort near Mahabaleshwar known for its history, architecture, and panoramic hill views."
  },
  {
    "title": "Tapola (Mini Kashmir)",
    "description":
      "Tapola is a scenic lake destination near Mahabaleshwar known for boating, water sports, and peaceful natural surroundings."
  },
  {
    "title": "Old Mahabaleshwar Temple",
    "description":
      "Old Mahabaleshwar Temple is a sacred Shiva temple known for its religious importance and serene atmosphere, attracting pilgrims and tourists."
  }
],



services: [
  {
    name: "Pune to Mahabaleshwar Tempo Traveller",
    description: "Pune to Mahabaleshwar Tempo Traveller service provides premium and spacious transportation for hill station trips, family vacations, sightseeing tours, and outstation journeys. Comfortable Tempo Traveller vehicles with experienced drivers ensure smooth and safe travel through ghat roads and highway routes. Pickup services are available from homes, hotels, railway stations, offices, and airport terminals across Pune. Vehicles offer pushback seating, air conditioning, music systems, and luggage space suitable for family and group travel requirements. Flexible booking options allow convenient Pune to Mahabaleshwar Tempo Traveller reservations."
  },
  {
    name: "Mahabaleshwar Traveller Hire Pune",
    description: "Mahabaleshwar traveller hire Pune service offers dependable transportation solutions for travelers planning hill station trips from Pune to Mahabaleshwar. Vehicles provide spacious seating and smooth highway travel suitable for tourism, group outings, family vacations, and sightseeing tours. Professional chauffeurs ensure punctual pickup and safe driving services throughout the journey. Pickup services are available across Pune including homes, hotels, offices, railway stations, and airports. Flexible booking options allow convenient Mahabaleshwar traveller hire reservations."
  },
  {
    name: "Luxury Tempo Traveller Mahabaleshwar Trip",
    description: "Luxury Tempo Traveller Mahabaleshwar trip service provides affordable and comfortable executive travel options for hill station journeys and outstation tours. Travelers can enjoy smooth trips with experienced drivers familiar with mountain roads, tourist destinations, and scenic routes. Vehicles ensure spacious seating and safe transportation suitable for family vacations, business travel, and sightseeing tours. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient luxury Mahabaleshwar traveller reservations."
  },
  {
    name: "Cheap Pune Mahabaleshwar Traveller",
    description: "Cheap Pune Mahabaleshwar traveller service provides economical transportation for passengers seeking comfortable and budget-friendly hill station travel. Vehicles offer spacious seating, luggage capacity, and smooth ride quality suitable for tourism, family outings, and personal journeys. Professional drivers ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient affordable Mahabaleshwar traveller reservations."
  },
  {
    name: "Outstation Tempo Traveller Mahabaleshwar",
    description: "Outstation Tempo Traveller Mahabaleshwar service offers comfortable transportation for groups traveling from Pune to Mahabaleshwar and nearby hill station destinations. Vehicles provide smooth highway travel with spacious seating suitable for one-day tours, weekend trips, and sightseeing travel. Professional drivers ensure punctual pickup and safe driving services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient outstation Mahabaleshwar traveller reservations."
  },
  {
    name: "Family Trip Traveller Pune Mahabaleshwar",
    description: "Family trip traveller Pune Mahabaleshwar service provides comfortable transportation for families, tourists, and groups traveling for vacations and sightseeing tours. Vehicles ensure smooth highway and ghat travel with spacious seating and luggage capacity suitable for tourism, family tours, and weekend trips. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available across Pune including homes, hotels, offices, railway stations, and airports. Flexible booking options allow convenient family trip traveller reservations."
  },
  {
    name: "Group Travel Mahabaleshwar Traveller",
    description: "Group travel Mahabaleshwar traveller service offers spacious transportation for group tours, corporate outings, sightseeing trips, and family vacations. Vehicles provide comfortable seating, air conditioning, and smooth highway performance suitable for long-distance journeys and hill station travel. Professional chauffeurs ensure safe driving and timely pickup services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient group travel traveller reservations."
  },
  {
    name: "AC Tempo Traveller Pune Mahabaleshwar",
    description: "AC Tempo Traveller Pune Mahabaleshwar service provides reliable transportation for local and outstation travel with premium air-conditioned interiors and spacious seating arrangements. Vehicles offer luggage space and comfortable travel suitable for family groups, corporate teams, and tourist travelers. Professional drivers ensure smooth travel and dependable pickup services throughout the trip. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient AC Mahabaleshwar traveller reservations."
  },
  {
    name: "One Way Traveller Pune Mahabaleshwar",
    description: "One way traveller Pune Mahabaleshwar service provides dependable transportation for one-side group travel from Pune to Mahabaleshwar and nearby tourist destinations. Comfortable vehicles ensure smooth highway and hill station travel suitable for tourism, corporate tours, and family vacations. Professional chauffeurs ensure safe driving and reliable transportation services throughout the journey. Pickup services are available across Pune including homes, hotels, railway stations, and airports. Flexible booking options allow convenient one-way traveller reservations."
  },
  {
    name: "Round Trip Traveller Mahabaleshwar",
    description: "Round trip traveller Mahabaleshwar service offers spacious and comfortable transportation for return travel from Pune to Mahabaleshwar and nearby sightseeing locations. Vehicles provide comfortable seating and luggage space suitable for family groups, business teams, and tourist travelers. Professional drivers ensure punctual transfers and safe transportation services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient round trip traveller reservations."
  },
  {
    name: "Best Tempo Traveller Pune Mahabaleshwar",
    description: "Best Tempo Traveller Pune Mahabaleshwar service offers premium transportation for sightseeing tours, family vacations, hill station trips, and business travel with return options. Vehicles ensure comfortable seating and smooth travel suitable for large family groups and corporate outings. Professional chauffeurs ensure safe driving and timely pickup services for all travel requirements. Pickup services are available from homes, hotels, banquet halls, railway stations, and airports across Pune. Flexible booking options allow convenient best Mahabaleshwar traveller reservations."
  },
  {
    name: "Tempo Traveller with Driver Mahabaleshwar",
    description: "Tempo Traveller with driver Mahabaleshwar service offers reliable group transportation for sightseeing tours, outstation travel, and family vacations. Vehicles provide spacious seating and luggage space suitable for family groups, corporate teams, and tourist travelers. Professional drivers ensure punctual transfers and safe transportation services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient traveller with driver reservations."
  },
  {
    name: "Premium Traveller Pune Mahabaleshwar",
    description: "Premium traveller Pune Mahabaleshwar service provides complete luxury transportation solutions for local and outstation group travel requirements. Vehicles ensure smooth highway travel suitable for tourism, corporate events, sightseeing tours, and family vacations. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient premium traveller reservations."
  },
  {
    name: "Pune Hill Station Traveller Rental",
    description: "Pune hill station traveller rental service offers comfortable and dependable transportation with modern vehicles and experienced chauffeurs. Vehicles are suitable for family trips, sightseeing tours, airport transfers, corporate outings, and long-distance hill station travel. Professional drivers ensure safe driving and reliable transportation services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient hill station traveller rental reservations."
  },
  {
    name: "Mahabaleshwar Tour Traveller Pune",
    description: "Mahabaleshwar tour traveller Pune service provides luxury transportation for groups looking for premium travel experiences with spacious seating and comfortable interiors. Vehicles are suitable for corporate events, destination outings, sightseeing trips, family vacations, and hill station tours. Professional chauffeurs ensure smooth journeys and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Mahabaleshwar tour traveller reservations."
  }
],

tableData: [
  ["Pune to Mahabaleshwar Tempo Traveller", "Mahabaleshwar Traveller Hire Pune"],
  ["Luxury Tempo Traveller Mahabaleshwar Trip", "Cheap Pune Mahabaleshwar Traveller"],
  ["Outstation Tempo Traveller Mahabaleshwar", "Family Trip Traveller Pune Mahabaleshwar"],
  ["Group Travel Mahabaleshwar Traveller", "AC Tempo Traveller Pune Mahabaleshwar"],
  ["One Way Traveller Pune Mahabaleshwar", "Round Trip Traveller Mahabaleshwar"],
  ["Best Tempo Traveller Pune Mahabaleshwar", "Tempo Traveller with Driver Mahabaleshwar"],
  ["Premium Traveller Pune Mahabaleshwar", "Pune Hill Station Traveller Rental"],
  ["Mahabaleshwar Tour Traveller Pune", "Pune to Mahabaleshwar Tempo Traveller"]
],


 whychoose: [
      {
        WhyChooseheading: "Reliable Pune to Mahabaleshwar Tempo Traveller on Rent",
        WhyChoosedescription: "Shivai Travels provides reliable Pune to Mahabaleshwar Tempo Traveller rental service with professional drivers, comfortable seating, and punctual pickup for smooth and safe hill station travel."
      },
      {
        WhyChooseheading: "Affordable Mahabaleshwar Tempo Traveller Pricing",
        WhyChoosedescription: "Shivai Travels offers affordable Pune to Mahabaleshwar Tempo Traveller on rent with transparent pricing and no hidden charges. Customers receive complete fare details before confirming their booking."
      },
      {
        WhyChooseheading: "24/7 Tempo Traveller Availability",
        WhyChoosedescription: "Our Pune to Mahabaleshwar Tempo Traveller rental service operates 24 hours a day for family vacations, corporate outings, sightseeing tours, weekend trips, and group travel requirements."
      },
      {
        WhyChooseheading: "Comfortable & Clean AC Tempo Travellers",
        WhyChoosedescription: "All Tempo Travellers provided by Shivai Travels are fully air-conditioned, sanitized, spacious, and regularly maintained to provide comfortable long-distance hill station travel experiences."
      },
      {
        WhyChooseheading: "One Way & Round Trip Booking Options",
        WhyChoosedescription: "Shivai Travels offers flexible travel options including one-way Pune to Mahabaleshwar Tempo Traveller booking, round-trip travel, sightseeing tours, and customized hill station packages."
      },
      {
        WhyChooseheading: "Perfect Vehicle for Family & Group Tours",
        WhyChoosedescription: "Our Tempo Travellers are ideal for family vacations, friend groups, corporate teams, tourists, and school trips with spacious seating, luggage capacity, and comfortable interiors."
      },
      {
        WhyChooseheading: "Doorstep Pickup Across Pune",
        WhyChoosedescription: "Shivai Travels provides convenient pickup from homes, offices, hotels, Pune Airport, railway stations, and all major Pune areas including Baner, Wakad, Hinjewadi, Kharadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for Ghat & Hill Routes",
        WhyChoosedescription: "Our experienced drivers are familiar with Pune to Mahabaleshwar ghat roads and hill station routes, ensuring safe driving and smooth travel for every mountain journey."
      }
    ]
  };

  const faqData = [
    { question: "What is Pune to Mahabaleshwar Tempo Traveller rental service?", answer: "Pune to Mahabaleshwar Tempo Traveller rental service provides comfortable group transportation for family tours, sightseeing trips, corporate outings, and weekend hill station travel." },
    { question: "Is Pune to Mahabaleshwar Tempo Traveller on rent available 24 hours?", answer: "Yes, Shivai Travels provides 24/7 Pune to Mahabaleshwar Tempo Traveller rental service." },
    { question: "Which Tempo Traveller seating options are available?", answer: "Shivai Travels offers 9 seater, 12 seater, 13 seater, 17 seater, and luxury Tempo Travellers for Mahabaleshwar travel." },
    { question: "Can I book Tempo Traveller for one-way Pune to Mahabaleshwar travel?", answer: "Yes, customers can book one-way as well as round-trip Pune to Mahabaleshwar Tempo Traveller services." },
    { question: "Do you provide Mahabaleshwar sightseeing packages?", answer: "Yes, Shivai Travels provides customized Mahabaleshwar sightseeing and hill station tour packages." },
    { question: "Are all Tempo Travellers air-conditioned?", answer: "Yes, all Tempo Travellers are fully air-conditioned and maintained for comfortable group travel." },
    { question: "Can I book Pune to Mahabaleshwar Tempo Traveller online?", answer: "Yes, customers can easily book Pune to Mahabaleshwar Tempo Traveller rental service online or through phone booking." },
    { question: "Do you provide Tempo Travellers for family and corporate group travel?", answer: "Yes, Shivai Travels provides Tempo Travellers for family vacations, corporate outings, school trips, and tourist groups." },
    { question: "Are Pune to Mahabaleshwar Tempo Traveller fares transparent?", answer: "Yes, Shivai Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for Pune to Mahabaleshwar Tempo Traveller rental?", answer: "Yes, advance booking is available and recommended during weekends, holidays, summer vacations, and peak tourist seasons." }
  ];

  const testimonials = [
    {
      id: 1,
      name: "Mr. Akshay Patil",
      feedback:
        "Booked Pune to Mahabaleshwar Tempo Traveller on rent with Shivai Travels. Comfortable vehicle, smooth hill journey, and excellent driver support for our family trip.",
      rating: 5
    },
    {
      id: 2,
      name: "Mrs. Snehal Kulkarni",
      feedback:
        "Excellent Pune to Mahabaleshwar Tempo Traveller rental service. Affordable pricing, clean vehicle, and wonderful hill station travel experience.",
      rating: 5
    }
  ];

  

  const Images = [
    { place: "/images/keyword/1.jpg", text: "Pune Outstation Cab Service", link: "Pune-Outstation-Cab-Service" },
    { place: "/images/keyword/2.jpg", text: "Pune Taxi Service", link: "Pune-Taxi-Service" },
    { place: "/images/keyword/3.jpg", text: "Pune Cab Booking", link: "Pune-Cab-Booking" },
    { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    { place: "/images/keyword/6.jpg", text: "Cheap Cabs in Pune", link: "Cheap-Cabs-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
    { place: "/images/keyword/8.jpg", text: "Corporate Cab Service Pune", link: "Corporate-Cab-Service-Pune" },
    { place: "/images/keyword/9.jpg", text: "Pune Airport Cab", link: "Pune-Airport-Cab" },
    { place: "/images/keyword/10.jpg", text: "Pune Railway Station Cab Service", link: "Pune-Railway-Station-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Pune One Way Cab Service", link: "Pune-One-Way-Cab-Service" },
    { place: "/images/keyword/12.jpg", text: "Pune Local and Outstation Cab", link: "Pune-Local-and-Outstation-Cab" },
    { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/15.jpg", text: "Pune to Nashik Cab Service", link: "Pune-to-Nashik-Cab-Service" },
    { place: "/images/keyword/16.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
    { place: "/images/keyword/17.jpg", text: "Pune to Kolhapur Cab", link: "Pune-to-Kolhapur-Cab" },
    { place: "/images/keyword/18.jpg", text: "Pune to Solapur Cab Service", link: "Pune-to-Solapur-Cab-Service" },
    { place: "/images/keyword/19.jpg", text: "Pune to Ahmednagar Taxi", link: "Pune-to-Ahmednagar-Taxi" },
    { place: "/images/keyword/20.jpg", text: "Pune to Sangli Cab", link: "Pune-to-Sangli-Cab" },
    { place: "/images/keyword/21.jpg", text: "Pune to Satara Cab Service", link: "Pune-to-Satara-Cab-Service" },
    { place: "/images/keyword/22.jpg", text: "Pune to Jalgaon Cab Service", link: "Pune-to-Jalgaon-Cab-Service" },
    { place: "/images/keyword/23.jpg", text: "Pune to Dhule Cab Service", link: "Pune-to-Dhule-Cab-Service" },
    { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
    { place: "/images/keyword/25.jpg", text: "Pune to Panvel Cab", link: "Pune-to-Panvel-Cab" },

  ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mahabaleshwar Tempo Traveller on Rent",
  "image": "https://shivaitravels.com/assets/images/pune-to-mahabaleshwar-tempo-traveller.jpg",
  "description": "Book Pune to Mahabaleshwar Tempo Traveller on rent with Shivai Travels for comfortable and safe hill station group travel. Ideal for family trips, corporate outings, and group tours. Available with AC comfort, professional driver, and flexible one-way and round-trip options.",
  "brand": {
    "@type": "Brand",
    "name": "Shivai Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹24/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://shivaitravels.com/pune-to-mahabaleshwar-tempo-traveller"
  }
};



  return (
    <div>


<Helmet>
  <title>Pune to Mahabaleshwar Tempo Traveller on Rent | Hill Station Trip | Shivai Travels | +91 9689815477</title>

  <meta
    name="description"
    content="Book Pune to Mahabaleshwar Tempo Traveller with Shivai Travels. Comfortable AC group travel vehicle for family trips, corporate outings, hill station tours, and weekend getaways. Available 24x7 with driver."
  />

  <meta
    name="keywords"
    content="pune to mahabaleshwar tempo traveller, mahabaleshwar traveller hire pune, luxury tempo traveller mahabaleshwar trip, cheap pune mahabaleshwar traveller, outstation tempo traveller mahabaleshwar, family trip traveller pune mahabaleshwar, group travel mahabaleshwar traveller, ac tempo traveller pune mahabaleshwar, one way traveller pune mahabaleshwar, round trip traveller mahabaleshwar, best tempo traveller pune mahabaleshwar, tempo traveller with driver mahabaleshwar, premium traveller pune mahabaleshwar, pune hill station traveller rental, mahabaleshwar tour traveller pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </div>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/12.jpeg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#3F1B0D', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Shivai Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shivai Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shivai Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919689815477" className="pc-call">+91 9689815477</a>
                    </div>

                    <div className="pc-cta">
                    <a
  href="https://wa.me/919689815477?text=Welcome%20to%20Shivai%20Travels!%20%F0%9F%9A%8C%0AWe%20are%20happy%20to%20assist%20you%20with%20comfortable%20and%20safe%20travel%20services.%20Please%20let%20us%20know%20how%20we%20can%20help%20you."
  target="_blank"
  rel="noopener noreferrer"
  className="pc-whats"
>
  <i className="bi bi-whatsapp"></i> WhatsApp
</a>
                      <a href="tel:+919689815477" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shivaitravels.com" className="pc-email">
                      booking@shivaitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shivai Travels</strong><br />
                      Shop no 1, Kamdhenu nagar, Guru mauli society, Vadgaon road, Near super bazar, Alandi, Pune 412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetomahabaleshwartempotraveller;